const invitationTexts = {
        invitation: {
                'fi': `Hei! XXX on ottanut käyttöön Piiri-sovelluksen yrityksen sisäiseen viestintään. Lataa Piiri-sovellus puhelimeesi ja kirjaudu sisään puhelinnumerollasi sekä tekstiviestillä tulevalla pin-koodilla.

Lataa sovellus Android-puhelimelle tästä linkistä: https://play.google.com/store/apps/details?id=fi.piirikit.piiri
            
Lataa sovellus iPhone-puhelimelle tästä linkistä: https://apps.apple.com/fi/app/piiri/id1529908235?l=fi
            
Tervetuloa Piiriin!`,

                'sv': `Hej! XXX har tagit i bruk Piiri-appen för intern kommunikation. Ladda piiri-appen till din telefon och logga in med ditt telefonnummer och pin-kodet du får via sms.

Ladda appen till en Android telefon via denna länk: https://play.google.com/store/apps/details?id=fi.piirikit.piiri

Ladda appen till en iPhone telefon via denna länk:  https://apps.apple.com/fi/app/piiri/id1529908235?l=fi                                

Välkommen till Piiri!`,

                'en': `Hi! XXX has started using the Piiri app for internal communication. Download the Piiri app to your phone and login with your phone number and the pin-code you will receive via sms.
                
Download the app for Android via this link: https://play.google.com/store/apps/details?id=fi.piirikit.piiri
        
Download the app for iPhone via this link:  https://apps.apple.com/fi/app/piiri/id1529908235?l=fi                                
        
Welcome to Piiri!`,

                'es': `Hola, XXX ha empezado a utilizar la aplicación Piiri para la comunicación interna. Descarga la aplicación Piiri en tu teléfono e inicia sesión con tu número de teléfono y el código pin que recibirás por sms.
                
Descargue la aplicación para Android a través de este enlace: https://play.google.com/store/apps/details?id=fi.piirikit.piiri
        
Descargue la aplicación para iPhone a través de este enlace: https://apps.apple.com/fi/app/piiri/id1529908235?l=fi                                
        
¡Bienvenido a Piiri!`,
                'lt': `Sveiki! „XXX“ pradėjo naudoti „Piiri“ programėlę vidinei komunikacijai. Atsisiųskite „Piiri“ programėlę į savo telefoną ir prisijunkite naudodami savo telefono numerį ir PIN kodą, kurį gausite SMS žinute.
                
Atsisiųskite programėlę „Android“ operacinei sistemai naudodami šią nuorodą: https://play.google.com/store/apps/details?id=fi.piirikit.piiri
        
Parsisiųskite programėlę „iPhone“ telefonui per šią nuorodą: https://apps.apple.com/fi/app/piiri/id1529908235?l=fi

Sveiki atvykę į „Piiri“!`,
                'no': `Hei! XXX har tatt i bruk Piiri-appen for intern kommunikasjon. Last ned Piiri-appen til telefonen din og logg inn med telefonnummeret ditt og PIN-koden du mottar via SMS.

Last ned appen for Android via denne lenken: https://play.google.com/store/apps/details?id=fi.piirikit.piiri

Last ned appen for iPhone via denne lenken: https://apps.apple.com/fi/app/piiri/id1529908235?l=fi

Velkommen til Piiri!`

        },
        reminder: {
                'fi': `Hei! Muista ladata Piiri-sovellus!
                
                XX on ottanut käyttöön Piiri-sovelluksen yrityksen sisäiseen viestintään. Lataa Piiri-sovellus puhelimeesi ja kirjaudu sisään puhelinnumerollasi sekä tekstiviestillä tulevalla pin-koodilla.

                Lataa sovellus Android-puhelimelle tästä linkistä: https://play.google.com/store/apps/details?id=fi.piirikit.piiri
                
                Lataa sovellus iPhone-puhelimelle tästä linkistä: https://apps.apple.com/fi/app/piiri/id1529908235?l=fi
                
                Tervetuloa XX:n Piiriin!`,

                'sv': `Hei! Muista ladata Piiri-sovellus!
                
                XX on ottanut käyttöön Piiri-sovelluksen yrityksen sisäiseen viestintään. Lataa Piiri-sovellus puhelimeesi ja kirjaudu sisään puhelinnumerollasi sekä tekstiviestillä tulevalla pin-koodilla.

                Lataa sovellus Android-puhelimelle tästä linkistä: https://play.google.com/store/apps/details?id=fi.piirikit.piiri
                
                Lataa sovellus iPhone-puhelimelle tästä linkistä: https://apps.apple.com/fi/app/piiri/id1529908235?l=fi
                
                Tervetuloa XX:n Piiriin!`,

                'en': `Hei! Muista ladata Piiri-sovellus!
                
                XX on ottanut käyttöön Piiri-sovelluksen yrityksen sisäiseen viestintään. Lataa Piiri-sovellus puhelimeesi ja kirjaudu sisään puhelinnumerollasi sekä tekstiviestillä tulevalla pin-koodilla.

                Lataa sovellus Android-puhelimelle tästä linkistä: https://play.google.com/store/apps/details?id=fi.piirikit.piiri
                
                Lataa sovellus iPhone-puhelimelle tästä linkistä: https://apps.apple.com/fi/app/piiri/id1529908235?l=fi
                
                Tervetuloa XX:n Piiriin!`,
        }
}

export default invitationTexts;